import { render, staticRenderFns } from "./tabBuyerConsoleFclBookingMasterUICustomLayout.vue?vue&type=template&id=5b6d701e&"
import script from "./tabBuyerConsoleFclBookingMasterUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabBuyerConsoleFclBookingMasterUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b6d701e')) {
      api.createRecord('5b6d701e', component.options)
    } else {
      api.reload('5b6d701e', component.options)
    }
    module.hot.accept("./tabBuyerConsoleFclBookingMasterUICustomLayout.vue?vue&type=template&id=5b6d701e&", function () {
      api.rerender('5b6d701e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabBuyerConsoleFclBookingMasterUICustomLayout.vue"
export default component.exports